import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserAuthenticationBaseComponent } from '@luggagehero/features/user';

@Component({
  selector: 'lh-user-authentication',
  templateUrl: './user-authentication.component.html',
  styleUrls: ['./user-authentication.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserAuthenticationComponent extends UserAuthenticationBaseComponent {
  public get isAppleSignInAvailable(): boolean {
    // Not supporting Apple Sign-in on web for now
    return false;
  }

  public signInWithApple(): Promise<void> {
    throw new Error('Apple sign-in is not supported on web');
  }

  public getUserConfirmation(prompt: string): boolean {
    return confirm(prompt);
  }
}
